import componentSelectorTemplate from './componentSelector.html';
import './componentSelector.scss';

const componentSelector = () => ({
    template: componentSelectorTemplate,
    restrict: 'E',
    scope: {
        moreInfo: '=',
        type: '=',
        boxTitle: '=',
        options: '=',
        multiSelect: '=',
        editSource: '<',
        closeBoxCallback: '&?',
        openModalCallback: '&?',
        defaultSelectedIdFieldName: '=',
        selectedOptions: '=',
        selectedSerie: '=',
        palettes: '=',
        changeStep: '&?',
        partDiscountImg: '='
    },
    controller: 'ComponentSelectorCtrl',
    controllerAs: 'componentSelector',
    bindToController: true
});

export default componentSelector;
